import React, { useState, useEffect } from 'react'
import { useToasts } from 'react-toast-notifications'
import { useDispatch, useSelector } from 'react-redux'

import MainModal from '../../../../components/dashboard/modal/MainModal'
import Flex from '../../../../components/layouts/Flex'
import { SingleDropdownSelect } from '../../../../components/dashboard/TalentPool/DropdownSelect'

import { setModal } from '../../../../store/actions/listsActions'
import { setInterviews } from '../../../../store/actions/recruitersActions'

import useMutation from '../../../../hooks/useMutation'

const ChangeInterviewer = () => {
  const [recruiterId, setRecruiterId] = useState('')
  const [interviewerName, setInterviewerName] = useState('')
  const { addToast } = useToasts()
  const dispatch = useDispatch()
  const { selectedInterview, interviews, recruiters } = useSelector(
    (state) => state.requisitions
  )
  const { data, loading, handleRequest, success, error } = useMutation()

  const handleSelectRecruiter = (e) => {
    const selectedIndex = e.target.selectedIndex
    const selectedOption = e.target.options[selectedIndex]
    const label = selectedOption.textContent
    setInterviewerName(label)
    setRecruiterId(e.target.value)
  }

  const handleSubmit = () => {
    if (!recruiterId) {
      return addToast('Recruiter field is required.', {
        appearance: 'error',
        autoDismiss: true,
      })
    }

    handleRequest(
      `/interviews/${selectedInterview.id}/change-interviewer`,
      {
        recruiter_id: recruiterId.toString(),
      },
      'PUT'
    )
  }

  // check if request was successful.
  useEffect(() => {
    if (data) {
      const filteredInterview = interviews.filter(
        (interview) => interview.id !== selectedInterview.id
      )

      const updatedInterview = selectedInterview
      updatedInterview.recruiter_id = recruiterId
      updatedInterview.interviewer = interviewerName

      dispatch(setInterviews([updatedInterview, ...filteredInterview]))

      addToast(data.message, {
        appearance: 'success',
        autoDismiss: true,
      })

      dispatch(setModal(''))
    }
  }, [success])

  // check if request was unsuccessful.
  useEffect(() => {
    if (error) {
      addToast(error.response.data || 'Something went wrong.', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }, [error])

  return (
    <>
      <MainModal
        title={`Change Interviewer`}
        buttonText="Submit"
        loading={loading}
        onClick={handleSubmit}
      >
        <Flex direction="column" gap="0.4rem" margin="1rem 0 0 0">
          <SingleDropdownSelect
            onChange={(e) => {
              handleSelectRecruiter(e)
            }}
            title="Interviewer"
          >
            <option value="">Choose an option</option>
            {recruiters?.map((recruiter) => {
              if (recruiter?.name) {
                return (
                  <option key={recruiter?.id} value={recruiter?.id}>
                    {recruiter?.name}
                  </option>
                )
              }
              return null
            })}
          </SingleDropdownSelect>
        </Flex>
      </MainModal>
    </>
  )
}

export default ChangeInterviewer
